module.exports = __webpack_public_path__ + "img/date.e7e600a9.svg";